import { Component, Input } from '@angular/core';
import { Color, ScaleType } from '@swimlane/ngx-charts';

@Component({
    selector: 'app-conv-leaks-extended',
    templateUrl: './conv-leaks-extended.component.html',
    styleUrl: './conv-leaks-extended.component.scss',
    standalone: false
})
export class ConvLeaksExtendedComponent {
	legend = false;
	animations = false;
	xAxis = true;
	yAxis = true;
	showYAxisLabel = true;
	showXAxisLabel = true;
	min = 0;
	max = 100;
	colorScheme: string | Color = {
		name: 'myScheme',
		selectable: true,
		group: ScaleType.Ordinal,
		domain: ['transparent', '#15A607', '#F1D50A', '#F1960A', '#F11C0A'],
	};

	@Input() fullTimeline: any[] = [];
	@Input() activeCategory: string = 'brows';

	chartData: any[] = [];

	ready = false;
	scrollOptions = { autoHide: false };

	displayMode: 'short' | 'long' = 'short';
	lastCurrentTime: number = 20;

	showHeatmap() {
		this.ready = true;
		this.calculateHeatMapData(20);
	}

	toggleDisplayMode(mode: 'short' | 'long') {
		if (this.displayMode !== mode) {
			this.displayMode = mode;
			this.calculateHeatMapData(this.lastCurrentTime); 
		}
	}

	calculateHeatMapData(currentTime: number) {
		const start = currentTime - 20;
		const dataChart = [];

		for (let index = start; index <= currentTime; index++) {
			const time = this.convertToTimerFormat(index);

			const data: any = {
				name: time,
				series: []
			};

			const currentFrame = this.fullTimeline[index] || null;

			if (currentFrame && currentFrame[this.displayMode] && currentFrame[this.displayMode][this.activeCategory]) {
				const targetData = currentFrame[this.displayMode][this.activeCategory];

				Object.keys(targetData).forEach(blendshapeName => {
					const formattedName = this.camelCaseToTitleCase(blendshapeName);

					const rawValue = targetData[blendshapeName] || 0;
					const trimmedValue = parseFloat(rawValue.toFixed(2));
					const percentageValue = parseFloat(Math.round(rawValue * 100).toFixed(2));

					data.series.push({
						name: formattedName,
						value: percentageValue,
						original: trimmedValue
					});
				});
			}

			dataChart.push(data);
		}

		this.chartData = [...dataChart];

		if (!this.ready) {
			this.ready = true;
		}
	}

	tooltipText(data: any): string {
		const cell = JSON.parse(JSON.stringify(data)).cell;

		let spanContent;

		if (Array.isArray(cell.original)) {
				const listItems = cell.original.map((item: any) => `<li>${item}</li>`).join('');
				spanContent = `<ol>${listItems}</ol>`;
		} else if (typeof cell.original === 'object' && cell.original !== null) { // Check for object and not null
				const valuesList = Object.entries(cell.original).map(([key, value]) => `<li>${key}: ${value}</li>`).join('');
				spanContent = `
						<div>
								<hr class="m-0">
								<ul class="no-list-style">${valuesList}</ul>
						</div>
				`;
		} else {
				spanContent = cell.original;
		}

		const span = `<span>${spanContent}</span>`;

		const tool = `
				<div class="p-1 fs-16">
						${cell.series} - ${cell.name}
						<hr class="m-0">
						${span}
				</div>
		`;

		return tool;
	}

	updateHeatmap(currentTime: number) {
		if (currentTime > 20) {
			this.calculateHeatMapData(currentTime);
		} else {
			this.calculateHeatMapData(20);
		}
	}

	camelCaseToTitleCase(text: string) {
		// 1. Insert spaces before each uppercase letter (except the first one).
		const spacedString = text.replace(/([A-Z])/g, ' $1');
	
		// 2. Capitalize the first letter.
		const titleCaseString = spacedString.charAt(0).toUpperCase() + spacedString.slice(1);
	
		return titleCaseString;
	}

	convertToTimerFormat(seconds: number) {
		if (seconds < 3600) {
			// Display "mm:ss" format for the first 60 minutes
			const minutes = Math.floor(seconds / 60);
			const formattedSeconds = (seconds % 60).toString().padStart(2, "0");
			const formattedMinutes = minutes.toString().padStart(2, "0");
			return `${formattedMinutes}:${formattedSeconds}`;
		} else {
			// After 60 minutes, switch to "hh:mm:ss" format
			const hours = Math.floor(seconds / 3600);
			const remainingSeconds = seconds % 3600;
			const minutes = Math.floor(remainingSeconds / 60);
			const formattedSeconds = (remainingSeconds % 60).toString().padStart(2, "0");
			const formattedMinutes = minutes.toString().padStart(2, "0");
			const formattedHours = hours.toString().padStart(2, "0");
			return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
		}
	}
}
